import React from 'react';
import styles from './SectionTitle.module.scss';

export interface SectionTitleProps {
  title?: string,
}

const SectionTitle = ({title}: SectionTitleProps) => {

  return (
    <div className={styles.title}>
      {title}
    </div>
  );
};

export default SectionTitle;
